import sliceCreator from '../../index.jsx';
import {CREATE_MANDAL} from '../../../constants/index.jsx';
const _createMandalAction = sliceCreator('CREATE_MANDAL', CREATE_MANDAL, 'post');

const { asyncAction: createMandalAction, reducer, clearData: clearCreateMandalAction } = _createMandalAction;

export default reducer;

export {
    createMandalAction,
    clearCreateMandalAction
}